<!-- 组包拆包操作 -->
<template>
  <div>
    <div class="search-ctn">
      <div class="search-ctn-left">
        <div class="search-name" v-if="Type == 1">组包数量</div>
        <div class="search-item" v-if="Type == 1">
          <el-input-number
            size="small"
            v-model.trim="opCount"
            :min="1"
          ></el-input-number>
          <!-- <el-input-number
            size="small"
            v-model.trim="opCount"
            :min="1"
            :max="inventory"
            v-if="Type == 2"
          ></el-input-number> -->
        </div>
        <el-button
          size="small"
          icon="el-icon-box"
          class="search-btn btn-primary"
          @click="submitCombo"
          v-if="Type == 1"
          >组包</el-button
        >
        <el-button
          size="small"
          icon="el-icon-s-release"
          class="search-btn btn-primary"
          @click="showSeDialog"
          v-if="Type == 2"
          >拆包</el-button
        >
        <div class="search-name" style="color: red">
          ( 目前套包【{{ goodName }}】拥有库存数 : {{ inventory }} )
        </div>
      </div>
    </div>
    <div class="search-ctn">
      <div class="search-ctn-left">
        <div class="search-name title">包编号 : {{ apCode }}</div>
        <div class="search-name title">包名称 : {{ goodName }}</div>
        <div class="search-name title">适用车型 : {{ autoSeries }}</div>
      </div>
    </div>
    <div class="table-ctn">
      <el-table
        v-loading="loading"
        :header-cell-style="{ background: '#F2F6FC' }"
        :data="tableData"
        border
        style="width: 100%"
      >
        <el-table-column
          width="160px"
          prop="APCode"
          label="汽配编码"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="GoodName"
          label="配件名称"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="AutoSerise"
          label="适用车型"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          width="80px"
          prop="Unit"
          label="单位"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          width="120px"
          prop="Count"
          label="单包数量"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          width="120px"
          prop="Inventory"
          label="现有库存数量"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          width="120px"
          label="组包所需库存数"
          v-if="Type == 1"
        >
          <template slot-scope="scope">
            <div
              :class="{
                'check-class': scope.row.Count * opCount > scope.row.Inventory,
              }"
            >
              {{ scope.row.Count * opCount }}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="dialog-footer">

    </div>    
    <el-dialog
      :close-on-click-modal="false"
      title="组包出仓"
      :visible.sync="outVisible"
      width="1000px"
      append-to-body
    >
      <div v-if="outVisible">
        <setComboOut
          :APList="APList"
          :SetId="SetId"
          :OpCount="opCount"
          @closeDialog="closeOutDialog"
        ></setComboOut>
      </div>
    </el-dialog>
    <!--   拆包     -->
    <el-dialog
      :close-on-click-modal="false"
      title="拆包商品"
      :visible.sync="seOutVisible"
      width="1000px"
      append-to-body
    >
      <div v-if="seOutVisible">
        <setSeparateOut
          :SetId="SetId"
          @closeDialog="closeSeOutDialog"
        ></setSeparateOut>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import setComboOut from "@/components/business/goods/setComboOut";
import setSeparateOut from "@/components/business/goods/setSeparateOut";
export default {
  name: "",
  props: ["SetId", "Type"],
  components: {
    setComboOut,
    setSeparateOut
  },
  data() {
    let userMsg = this.$util.getLocalStorage("userMsg");
    return {
      loading: false,
      goodName: "",
      apCode: "",
      autoSeries: "",
      inventory: 0,
      opCount: 1,
      outVisible: false,
      seOutVisible:false,
      searchData: {
        EntpId: userMsg.EntpId,
        SetId: this.SetId,
      },
      submitData: {
        UserId: userMsg.EmployeeId,
        SetId: this.SetId,
        OpCount: 0,
      },
      tableData: [],
      APList: [],
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    getTableData() {
      this.loading = true;
      this.$util
        .axiosGet({
          url: "/api/EntpGoods/GetGoodsSetDetailsContainWH",
          data: this.searchData,
        })
        .then((res) => {
          this.loading = false;
          let data = res.data;
          if (!data) data = {};
          this.tableData = data.DetailList;
          this.apCode = data.APCode;
          this.goodName = data.GoodName;
          this.autoSeries = data.AutoSerise;
          this.inventory = data.Inventory;
        });
    },
    submitCombo() {
      if (this.opCount > 0) {
        //校验
        for (let i = 0; i < this.tableData.length; i++) {
          if (
            this.tableData[i].Count * this.opCount >
            this.tableData[i].Inventory
          ) {
            this.$util.warningMsg("库存数量不足以进行组包");
            return;
          }
        }
        this.APList = this.tableData;
        //弹出出仓层
        this.outVisible = true;
      } else this.$util.warningMsg("请填写正确的数量");
    },
    closeOutDialog(fresh) {
      this.outVisible = false;
      this.APList = [];
      this.$emit("closeDialog",fresh);
    },
    showSeDialog(){
      this.seOutVisible = true;
    },
    closeSeOutDialog(fresh){
      this.seOutVisible = false;
      this.$emit("closeDialog",fresh);
    }
  },
};
</script>
<style lang="less" scoped>
.title {
  font-size: 18px;
}
.check-class {
  color: red;
}
</style>